import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPreLog } from '../interfaces/pre-log';
import { IPreLogDisplay } from '../interfaces/pre-log-display';
import { IPreLogSubmission } from '../interfaces/pre-log-submission';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class PreLogService {
    private rootUrl: string = "/api/pre-log";
    private storageKey: string = "CurrentPreLog";

    constructor(private httpClient: HttpClient, @Inject(SESSION_STORAGE) private readonly storage: WebStorageService) { }

    public createPreLog(preLog: IPreLogSubmission): Observable<number> {
        return this.httpClient.post<number>(this.rootUrl, preLog);
    }

  public getPreLog(id: number): Observable<IPreLogDisplay> {
        const url = this.rootUrl + "/" + id;
        return this.httpClient.get<IPreLogDisplay>(url);
    }

    public isDuplicateBarcode(barcode: string): Observable<boolean> {
        const url = this.rootUrl + "/is-duplicate-barcode?barcode=" + barcode;
        return this.httpClient.get<boolean>(url);
    }

    public setCurrentPreLog(preLog: IPreLog): void {
        this.storage.set(this.storageKey, preLog);
    }

    public getCurrentPreLog(): IPreLog {
      return this.storage.get(this.storageKey);
    }

    public clearCurrentPreLog(): void {
        this.storage.remove(this.storageKey);
    }
}
